import apiClient from './config';
import { Nivel, EntityUsage, ReassignResponse, DeleteResponse } from "../../types/index"


// Servicios para obtener, crear, actualizar y eliminar niveles
export const fetchNiveles = async (): Promise<Nivel[]> => {
    const response = await apiClient.get('/niveles');
    return response.data;
};

// Funcion para crear niveles llamando al endpoint POST /niveles
export const createNivel = async (nivel: Nivel) => {
    const response = await apiClient.post('/niveles', nivel);
    return response.data;
};


// Funcion para actualizar niveles llamando al endpoint PUT /niveles/:nivelId
export const updateNivel = async (nivel: Nivel): Promise<Nivel> => {
    const response = await apiClient.put(`/niveles/${nivel._id}`, nivel);
    return response.data;
};



// B1 — uso de un nivel. Además de clases y plantillas, cuenta plazas activas y
// recuperaciones pendientes, que también se reasignan.
export const fetchLevelUsage = async (nivelId: string): Promise<EntityUsage> => {
    const response = await apiClient.get(`/niveles/${nivelId}/usage`);
    return response.data;
};

// B1 — mueve clases futuras, plantillas, plazas activas y recuperaciones
// pendientes de este nivel a otro.
export const reassignLevel = async (
    nivelId: string,
    targetId: string
): Promise<ReassignResponse> => {
    const response = await apiClient.post(`/niveles/${nivelId}/reassign`, { targetId });
    return response.data;
};

// Funcion para eliminar niveles llamando al endpoint DELETE /niveles/:nivelId
// B1: devuelve `archived` — ver la nota en instructorService.
export const deleteNivel = async (nivelId: string): Promise<DeleteResponse> => {
    const response = await apiClient.delete(`/niveles/${nivelId}`);
    return response.data;
};

